import { AccordionFolderItem } from 'twyne-new.ui'

import { useThemeTypes } from "@/modules/cms/views/post/components/builder/context"
import useTypeData from '@/modules/cms/views/post/components/builder/hooks/useTheme/useTypeData'

import EditingTitle from "./EditingTitle"
import Template from "./Template"
import TypeActions from "./TypeActions"

export default function Type({ idx, data, isActive, onSelect }) {
  const { remove } = useThemeTypes()
  const { name, templates, isEditing, isNew } = useTypeData(data)

  const handleAddTemplate = template => {
    if (template) {
      templates.add(template)
    } else {
      templates.add('New Template', true)
    }
  }

  const handleRemoveTemplate = idx => {
    templates.remove(idx)
  }

  return <AccordionFolderItem
    value={name.value}
    title={<EditingTitle value={name} isEditing={isEditing} isNew={isNew} />}
    actions={<TypeActions setIsEditing={isEditing.setValue} onRemove={() => remove(idx)} onAdd={handleAddTemplate} />}
  >
    {templates.list.map((data, idx) => <Template
      key={idx}
      data={data}
      onSelect={onSelect}
      isActive={isActive}
      onRemove={() => handleRemoveTemplate(idx)}
    />)}
  </AccordionFolderItem>
}

